export default __webpack_public_path__ + "static/media/Du Circo.438c979f.png";